export default "__VITE_ASSET__f67485b0__"